export default "__VITE_ASSET__Dh$fZ4Le__"